(() => {
  const initialize = (scope) => {
    scope.querySelectorAll('[data-np]').forEach(root => {
      if (root.dataset.initialized) return;
      root.dataset.initialized = 'true';
      const form = root.querySelector('form');
      const submit = root.querySelector('[data-submit]');
      const sticky = root.querySelector('[data-sticky]');
      const stickyButton = root.querySelector('[data-sticky-add]');
      const error = root.querySelector('[data-error]');
      const qty = form.querySelector('[name="quantity"]');
      const scents = [...form.querySelectorAll('[data-scent]')];
      const addons = [...form.querySelectorAll('[data-addon]')];
      const fourth = form.querySelector('[data-extra-select]');
      const translations = JSON.parse(root.querySelector('[data-np-translations]').textContent);
      const format = amount => new Intl.NumberFormat(document.documentElement.lang || 'es-ES', {style:'currency',currency:root.dataset.currency || 'EUR'}).format(amount / 100);
      let pending = false;
      const unavailable = scents.some(select => !select.options.length) || submit.disabled;
      const extras = root.querySelector('[data-extras]');
      if (extras) extras.hidden = false;
      const chosen = () => addons.filter(input => input.checked);
      const update = () => {
        scents.forEach(select => {
          const notes = select.closest('.np-scent-row').querySelector('[data-scent-notes]');
          notes.textContent = select.selectedOptions[0]?.dataset.notes || translations.noScents;
        });
        addons.forEach(input => input.closest('.np-addon').classList.toggle('is-selected', input.checked));
        const extraWax = addons.find(input => input.dataset.addon === 'wax');
        if (fourth) {
          const selected = Boolean(extraWax?.checked);
          fourth.disabled = !selected;
          fourth.closest('[data-extra-select-wrap]').hidden = !selected;
          if (extraWax && fourth.selectedOptions[0]) {
            extraWax.dataset.price = fourth.selectedOptions[0].dataset.price;
            const price = Number(extraWax.dataset.price);
            const comparePrice = Number(fourth.selectedOptions[0].dataset.comparePrice || 0);
            const card = extraWax.closest('.np-addon');
            card.querySelector('[data-addon-price]').textContent = '+' + format(price);
            const comparison = card.querySelector('[data-addon-compare]');
            const saving = card.querySelector('[data-addon-saving]');
            comparison.hidden = saving.hidden = comparePrice <= price;
            comparison.textContent = format(comparePrice);
            saving.textContent = translations.save.replace('__amount__', format(comparePrice - price));
          }
        }
        const selected = chosen();
        const total = Number(root.dataset.basePrice) * Math.max(1, Math.floor(Number(qty.value) || 1)) + selected.reduce((sum, input) => sum + Number(input.dataset.price), 0);
        root.querySelectorAll('[data-total]').forEach(node => node.textContent = format(total));
        const hint = root.querySelector('[data-extra-hint]');
        if (hint) hint.textContent = selected.length ? (selected.length === 1 ? '1 extra seleccionado' : translations.extraCount.replace('__count__', selected.length)) : translations.extraHint;
      };
      const buildItems = () => {
        const properties = {};
        new FormData(form).forEach((value, key) => {
          const match = /^properties\[(.+)\]$/.exec(key);
          if (match) properties[match[1]] = value;
        });
        const items = [{id:Number(form.querySelector('[name="id"]').value),quantity:Number(qty.value),properties}];
        chosen().forEach(input => {
          const item = {id:Number(input.dataset.addon === 'wax' ? fourth.value : input.dataset.variant),quantity:1};
          if (input.dataset.addon === 'samples') {
            const aromas = scents.map(select => select.value);
            if (addons.some(addon => addon.dataset.addon === 'wax' && addon.checked)) aromas.push(fourth.selectedOptions[0].textContent);
            item.properties = {'Complemento de':'Pack Ritual de Otoño','Muestras':'3 aromas sorpresa de 20 g','Evitar repetir si es posible':aromas.join(', ')};
          }
          items.push(item);
        });
        return items;
      };
      form.addEventListener('change', update);
      form.addEventListener('input', update);
      form.addEventListener('submit', async event => {
        event.preventDefault();
        event.stopImmediatePropagation();
        if (pending || unavailable || !form.reportValidity()) return;
        pending = true;
        error.hidden = true;
        submit.disabled = stickyButton.disabled = true;
        submit.querySelector('span').textContent = root.dataset.adding;
        submit.setAttribute('aria-busy', 'true');
        stickyButton.textContent = root.dataset.adding;
        try {
          const response = await fetch(root.dataset.addUrl, {method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:buildItems()})});
          const body = await response.json();
          if (!response.ok) throw new Error(body.description || body.message || root.dataset.error);
          window.location.assign(root.dataset.cartUrl);
        } catch (exception) {
          pending = false;
          error.textContent = exception.message || root.dataset.error;
          error.hidden = false;
          submit.disabled = stickyButton.disabled = unavailable;
          submit.querySelector('span').textContent = root.dataset.addLabel;
          submit.removeAttribute('aria-busy');
          stickyButton.textContent = root.dataset.addLabel;
          error.scrollIntoView({block:'center',behavior:'smooth'});
        }
      });
      stickyButton.addEventListener('click', () => {
        if (sticky.dataset.action === 'choose') {
          root.querySelector('#np-choose').scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
        } else { form.requestSubmit(submit); }
      });
      if (unavailable) {
        submit.disabled = stickyButton.disabled = true;
        if (scents.some(select => !select.options.length)) {error.hidden = false;error.textContent = translations.noScents;}
      }
      const syncSticky = () => {
        const rect = submit.getBoundingClientRect();
        const before = rect.top > window.innerHeight - 80;
        const past = rect.bottom < 100;
        const rootRect = root.getBoundingClientRect();
        const visible = (before || past) && rootRect.top < window.innerHeight && rootRect.bottom > 100 && !unavailable;
        sticky.dataset.action = before ? 'choose' : 'add';
        if (!pending) stickyButton.textContent = before ? translations.chooseLabel : root.dataset.addLabel;
        sticky.hidden = !visible;
        root.classList.toggle('np-has-sticky', visible);
      };
      if ('IntersectionObserver' in window) new IntersectionObserver(syncSticky, {rootMargin:'-100px 0px 0px',threshold:0}).observe(submit);
      window.addEventListener('scroll', syncSticky, {passive:true});
      window.addEventListener('resize', syncSticky, {passive:true});
      window.addEventListener('pageshow', () => {
        pending = false;
        submit.disabled = stickyButton.disabled = unavailable;
        submit.removeAttribute('aria-busy');
        if (!unavailable) {submit.querySelector('span').textContent = stickyButton.textContent = root.dataset.addLabel;}
        update();syncSticky();
      });
      root.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        target.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, true);
      root.querySelectorAll('[data-show-slide]').forEach(button => button.addEventListener('click', () => {
        root.querySelectorAll('[data-slide]').forEach(slide => slide.hidden = slide.dataset.slide !== button.dataset.showSlide);
        root.addEventListener('click', event => {
        const link = event.target.closest('a[href^="#"]');
        if (!link) return;
        const target = root.querySelector(link.getAttribute('href'));
        if (!target) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        target.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      }, true);
      root.querySelectorAll('[data-show-slide]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      const dialog = root.querySelector('[data-photo-dialog]');
      root.querySelector('[data-zoom]').addEventListener('click', () => {
        const active = root.querySelector('[data-slide]:not([hidden])');
        const image = active.querySelector('img');
        const target = dialog.querySelector('img');
        target.src = image.currentSrc || image.src;
        target.alt = image.alt;
        target.classList.remove('np-rotate');
        dialog.showModal();
      });
      root.querySelector('[data-close-dialog]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {if (event.target === dialog) dialog.close();});
      update();syncSticky();
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();




